// material-ui
import { Grid, Stack, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Box } from '@mui/material';

// project import
import AuthWrapper from './AuthWrapper';

const Icon = () => (
  <Box 
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      margin: 'auto',
      marginBottom: 3,
      width: 80,  
      height: 80,
      borderRadius: '50%',
      backgroundColor: '#D1F7CE',


    }}
  >
    <CheckIcon 
      sx={{
        fontSize:50,
        color: '#2D900B',
      }}
    />
  </Box>
);


const CustomPortal = ({ header, Component, showStatus=false , showVersion = false}) => (
  <AuthWrapper showVersion={showVersion}>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        {showStatus && (<Icon/>)}
        {!showStatus ? 
          <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ mb: { xs: -0.5, sm: 0.5 } }}>
            <Typography variant="h3">{header}</Typography>
          </Stack>
          : 
          <Stack >
            <Typography variant="h3" align="center" >{header}</Typography>
          </Stack>
        }
        
      </Grid>
      <Grid item xs={12}>
        <Component />
      </Grid>
    </Grid>
  </AuthWrapper>
);

export default CustomPortal;
